import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { addSeconds, format } from 'date-fns';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription, finalize, map, takeUntil, timer } from 'rxjs';
import { DataService } from 'src/app/helpers/data.service';
import { iDueTaskDto } from 'src/app/helpers/Interfaces/task';
import { EmployeeService } from '../../../hr360/employee/employee.service';
import { TasksService } from '../../../i-team/tasks/tasks.service';
import { StatusesService } from '../../../setup/statuses/statuses.service';
import { AttendanceService } from '../attendance.service';

@Component({
  selector: 'app-attendance-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss'],
})
export class AddComponent implements OnInit, OnDestroy {
  @ViewChild('addAttendanceModal') addAttendanceModal!: TemplateRef<any>;
  @ViewChild('messageModal') messageModal!: TemplateRef<any>;
  @Output('reloadParent') reloadParent = new EventEmitter<undefined>();
  @ViewChild('dueTasksModal') public dueTasksModal!: TemplateRef<any>;

  mode: 'default' | 'remote' = 'default';

  protected time: string = '';
  protected date: string = '';
  protected attendance: any;
  protected loading: boolean = false;
  protected subscription!: Subscription;
  protected employeeId: string;
  protected radioModel: string = '';

  private _workType: string = '';
  public get workType(): string {
    return this._workType;
  }
  public set workType(v: string) {
    this._workType = v;

    if (this.mode === 'remote') {
      this.radioModel = 'Remote';
      return;
    }

    if (v == 'Hybrid' || v == 'Remote') {
      this.radioModel = 'Remote';
    } else {
      this.radioModel = v;
    }
  }

  private _unsubscribeAll: Subject<any> = new Subject();

  protected dueTaskLoading: boolean = false;
  protected dueTasks: any[] = [];
  protected dModal: any;
  protected values: {
    [id: string]: { value: string; loading: boolean; error: boolean };
  } = {};

  constructor(
    private _attendanceServ: AttendanceService,
    private _dataServ: DataService,
    private _toastrServ: ToastrService,
    private _employeeServ: EmployeeService,
    private _taskServ: TasksService,
    private _modalServ: NgbModal,
    private _statusServ: StatusesService
  ) {
    this.employeeId = _dataServ.employeeValue?.id;
    this.workType = _dataServ.employeeValue?.workType;
  }

  ngOnInit(): void {
    this.loading = true;
    this._attendanceServ.GetTime().subscribe({
      next: (t: any) => {
        var dd = new Date(t);
        this.subscription = timer(0, 1000).subscribe((time) => {
          dd = addSeconds(dd, 1);
          this.time = format(dd, 'hh:mm:ss a');
          this.date = format(dd, 'EEEE, MMMM yy');
        });
        this._attendanceServ
          .CheckAttendance(this.employeeId)
          .pipe(
            finalize(() => {
              this.loading = false;
            })
          )
          .subscribe({
            next: (attendance) => {
              this.attendance = attendance;

              if (this.mode === 'remote') {
                this.radioModel = 'Remote';
                return;
              }

              this.radioModel =
                attendance?.type ||
                (this.workType == 'Hybrid' || this.workType == 'Remote'
                  ? 'Remote'
                  : 'On Site');
            },
            error: () => {
              this._toastrServ.error('Something went wrong...');
            },
          });
      },
    });
  }
  MarKAttendance(modal: any) {
    //debugger;
    const payload = {
      employeeId: this.employeeId,
      id: this.attendance?.id ?? null,
      type: this.attendance?.type || this.radioModel,
    };
    // console.log(payload);
    if (!(this.attendance !== '' && Boolean(this.attendance?.signOut))) {
      this.loading = true;
      // console.log(this.attendance);
      if (payload.id) {
        this._taskServ.GetLastTimeTrack(this.employeeId).subscribe({
          next: (res) => {
            if (res && res.status == 'start') {
              this._modalServ.open(this.messageModal, {
                scrollable: false,
                centered: true,
                beforeDismiss: (): boolean => {
                  return true;
                },
                keyboard: false,
                size: 'md',
              });
              this.loading = false;
              modal.dismiss();
            } else {
              this.checkDueTasks(
                () => {
                  this.loading = false;
                  modal.dismiss();
                },
                () => this.FinalMethod(payload, modal)
              );
            }
          },
        });
      } else this.FinalMethod(payload, modal);
    }
  }
  FinalMethod(payload: any, modal: any) {
    this._attendanceServ
      .MarkAttendance(payload)
      .pipe(
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe({
        next: (attendance) => {
          if (attendance.signOut) {
            this._employeeServ
              .ChangeStatus({
                employeeId: this._dataServ.employeeValue.id,
                status: 0,
              })
              .subscribe({
                next: (res) => {
                  this._dataServ.setEmployee({
                    ...this._dataServ.employeeValue,
                    status: 0,
                  });
                },
              });
          }

          this.attendance = attendance;
          this.reloadParent.emit(undefined);
          modal.dismiss();
        },
        error: (err: unknown) => {
          if (err instanceof HttpErrorResponse && err.status === 403) {
            return;
          }

          this._toastrServ.error(
            'Error occurred while marking the attendance...'
          );
        },
      });
  }
  open() {
    // this._taskServ.setShowModal('attendance');
  }
  close() {
    this.time = '';
    this.date = '';
  }
  protected closeModal(modal: any) {
    modal.dismiss('Cross click');
  }
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
  checkDueTasks(ifCallback: Function, elseCallback: Function) {
    this.dueTaskLoading = true;
    this.dueTasks = [];
    this.values = {};
    this._taskServ
      .GetDueTasks(this._dataServ.employeeValue?.id, true)
      .pipe(
        map((x) => {
          const res = x.data.map((y) => {
            const z: iDueTaskDto = { ...y, expand: false };
            if (!(z.id! in this.values)) {
              this.values[z.id!] = { error: false, loading: false, value: '' };
            }
            return z;
          });
          return res;
        }),
        takeUntil(this._unsubscribeAll)
      )
      .subscribe({
        next: (res) => {
          this.dueTasks = res;
          if (this.dueTasks.length > 0) {
            this._modalServ.open(this.dueTasksModal, {
              backdrop: 'static',
              centered: true,
              keyboard: false,
              size: 'lg',
            });
            ifCallback();
          } else elseCallback();
        },
        error: (er) => {
          console.warn(er);
          this._toastrServ.error(
            'Something went wrong while fetching Due Tasks...'
          );
        },
        complete: () => {
          this.dueTaskLoading = false;
        },
      });
  }
  isBodyEmptyOrNull(body: string) {
    if (!body) {
      return true;
    }

    // Remove leading and trailing whitespaces from the body content
    let bodyContent = body.trim();

    // Check for null or empty body
    if (bodyContent === null || bodyContent === '') {
      return true;
    }

    // Create a temporary DOM element to parse the HTML content
    let tempDiv = document.createElement('div');
    tempDiv.innerHTML = bodyContent;

    // Check if the body contains only an empty paragraph
    let paragraphs = tempDiv.getElementsByTagName('p');
    if (paragraphs.length === 1 && paragraphs[0].innerHTML.trim() === '') {
      return true;
    }

    return false;
  }
  submit(id: string, modal: any) {
    if (!this.values[id].loading) {
      if (this.isBodyEmptyOrNull(this.values[id].value)) {
        this.values[id].error = true;
        return;
      }
      this.values[id].error = false;
      this.values[id].loading = true;
      const payload = {
        taskId: id,
        employeeId: this._dataServ.employeeValue?.id,
        body: this.values[id].value,
      };

      this._taskServ.AddConversation(payload).subscribe({
        next: (con) => {
          this.changeStatus(id, () => {
            this.values[id].loading = false;
            delete this.values[id];
            this.dueTasks = this.dueTasks.filter((x) => x.id !== id);
            if (this.dueTasks.length == 0) modal?.dismiss();
          });
        },
        error: (er) => {
          console.warn(er, 'error adding conversation');
          this._toastrServ.error(
            'Something went wrong while submitting reason!'
          );
        },
      });

      // console.log(payload);
    }
  }
  changeStatus(taskId: string, cb?: Function) {
    this._statusServ.GetStatusByName('Open').subscribe({
      next: (status) => {
        const statusPayload = {
          statusId: status?.id,
          employeeId: this._dataServ.employeeValue?.id,
          customerId: null,
          taskId: taskId,
        };
        this._taskServ.AddTaskStatus(statusPayload).subscribe({
          next: (res) => {
            if (cb) {
              cb();
            }
          },
          error: (er) => {
            console.warn(er, 'error while changing status');
            this._toastrServ.error(
              'Something went wrong while submitting reason!'
            );
          },
        });
      },
      error: (er) => {
        console.warn(er, 'error while fetching status by name');
        this._toastrServ.error('Something went wrong while submitting reason!');
      },
    });
  }
}
